module.exports = __webpack_public_path__ + "img/Huang.4d700b24.jpeg";